<template>
  <!-- 对话框 -->
  <el-drawer title="修改用户信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">

    <!-- 基本信息表单 -->
    <div class="form-box">

      <el-form ref="form" :model="submit_data" label-width="80px" style="overflow-y: auto; height: 85vh;">

        <el-form-item label="客户姓名:" label-width='120px'>
          <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" style="width: 80%;">
          </el-input>
        </el-form-item>

        <el-form-item label="手机号码:" label-width='120px'>
          <el-input v-model="submit_data.phone" :placeholder="submit_rules.phone.placeholder" style="width: 80%;"
            maxlength=11>
          </el-input>
        </el-form-item>

        <el-form-item label="密码:" label-width='120px'>
          <el-input v-model="submit_data.password" style="width: 80%;" show-password>
          </el-input>
        </el-form-item>




        <el-form-item label="所属集团:" label-width='120px'>
          <el-select v-model="value_group_code" placeholder="请选择集团" @visible-change="modeVisibleChange"
            @change="modeChange" clearable @keyup.enter.native="searchOrderLists" style="position: relative">
            <el-option v-for="item in options_group_code" :key="item.value" :label="item.group_name"
              :value="item.group_wallet_code">
            </el-option>


            <selectPages :search_data="group_options_data" :result_data="selectPages_data"
              @selectPages_function="selectPages_function"></selectPages>


          </el-select>
        </el-form-item>



        <!-- 下拉选择性别 -->
        <el-form-item label="性别:" label-width='120px'>
          <el-select v-model="value_sex_code" placeholder="请选择性别" style="width: 150px; margin-right: 20px;"
            @change="sexChange" clearable>
            <el-option v-for="(item, index) in sex_select_arrway" :label="item.alias" :value="item.val"></el-option>
          </el-select>
        </el-form-item>

        <!-- 下拉选择状态 -->
        <el-form-item label="状态:" label-width='120px'>
          <el-select v-model="value_status_code" placeholder="请选择状态" style="width: 150px; margin-right: 20px;"
            @change="statusChange" clearable>
            <el-option v-for="(item, index) in status_select_arrway" :label="item.alias" :value="item.val"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="身份证号码:" label-width='120px'>
          <el-input v-model="submit_data.id_card" :placeholder="submit_rules.id_card.placeholder" style="width: 80%;"
            maxlength="18">
          </el-input>
        </el-form-item>

        <el-form-item label="紧急联系人姓名:" label-width='120px'>
          <el-input v-model="submit_data.urgent_name" :placeholder="submit_rules.urgent_name.placeholder"
            style="width: 80%;">
          </el-input>
        </el-form-item>

        <el-form-item label="紧急联系人电话:" label-width='120px'>
          <el-input v-model="submit_data.urgent_phone" :placeholder="submit_rules.urgent_phone.placeholder"
            style="width: 80%;" maxlength=11>
          </el-input>
        </el-form-item>

        <el-form-item label="车牌号码:" label-width='120px'>
          <el-input v-model="submit_data.car_number" :placeholder="submit_rules.car_number.placeholder"
            style="width: 80%;">
          </el-input>
        </el-form-item>

        <el-form-item label="极光编码:" label-width='120px'>
          <el-input v-model="submit_data.registration_id" :placeholder="submit_rules.registration_id.placeholder"
            style="width: 80%;" maxlength=19>
          </el-input>
        </el-form-item>

        <el-form-item label="备注:" label-width='120px'>
          <el-input v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder" style="width: 80%;"
            maxlength=19>
          </el-input>
        </el-form-item>

        <div v-if="money_show">
          <el-form-item label="账户金额:" label-width='120px'>
            {{ money_data.balance }}元
          </el-form-item>

          <el-form-item label="提现:" label-width='120px'>
            {{ money_data.cash }}元
          </el-form-item>

          <el-form-item label="冻结:" label-width='120px'>
            {{ money_data.frozen }}元
          </el-form-item>

          <el-form-item label="提现中:" label-width='120px'>
            {{ money_data.cashing }}元
          </el-form-item>

          <el-form-item label="拖欠款:" label-width='120px'>
            {{ money_data.arrears }}元
          </el-form-item>
          <div v-if="balance!=''">
            <el-form-item label="集团金额:" label-width="120px">
            {{balance}}元
          </el-form-item>
          </div>
          
        </div>

      </el-form>

      <!-- 对话框底部按钮 -->
      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-drawer>
</template>

<script>
  var _this;

  import bus from '../../common/bus.js';
  export default {
    props: {
      'isShow': Boolean,
      'data': '',
      'money': Boolean
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        if (_this.money) {
          _this.money_show = true;
          _this.$post(
              "/consumer/getConsumerWalletDetails", {
                consumer_code: _this.data
              }
            )
            .then(res => {

              _this.money_data = res.data;

            }).catch(res => {

            })




        }



        console.log(this.data);

        _this.$post(
            "/consumer/getConsumerDetails", {
              consumer_code: _this.data
            }
          )
          .then(res => {
            _this.value_sex_code = res.data.sex.alias;
            _this.value_status_code = res.data.status.alias;


            _this.submit_data.consumer_code = _this.data;
            _this.submit_data.name = res.data.name;
            _this.submit_data.phone = res.data.phone;
            _this.submit_data.password = res.data.password;
            _this.submit_data.id_card = res.data.id_card;
            _this.submit_data.sex = res.data.sex.val;
            _this.submit_data.status = res.data.status.val;
            _this.submit_data.urgent_name = res.data.urgent_name;
            _this.submit_data.urgent_phone = res.data.urgent_phone;
            _this.submit_data.car_number = res.data.car_number;
            _this.submit_data.remarks = res.data.remarks;
            _this.submit_data.registration_id = res.data.registration_id;


            _this.value_group_code = res.data.group_wallet_code.name;
            _this.submit_data.group_wallet_code = res.data.group_wallet_code.code;

            if(res.data.group_wallet_code.balance == ''){

                _this.balance = 0.00
            }else{
              _this.balance = res.data.group_wallet_code.balance;
            }
            

            _this.group_wallet_code = res.data.group_wallet_code.code

            _this.sex_select_arrway = res.data.sex.select_array;
            _this.status_select_arrway = res.data.status.select_array;
          }).catch(res => {

          })


      },

    },
    data() {
      return {
        balance: '',

        show: false,

        //选择性别
        value_sex_code: '',

        money_show: false,
        money_data: [],

        //选择状态
        value_status_code: '',

        sex_select_arrway: [],
        status_select_arrway: [],

        selectPages_data: [],


        // 所属集团
        value_group_code: '',
        options_group_code: [],
        group_options_data: {
          page: 1,
          limit: 5,
        },



        // 表单数据
        submit_data: {
          consumer_code: '',
          name: '',
          phone: '',
          password: '',
          sex: '',
          status: '',
          id_card: '',
          urgent_name: '',
          urgent_phone: '',
          car_number: '',
          remarks: '',
          registration_id: '',
          group_wallet_code:'',
          clear_field:''

        },

        submit_rules: {
          consumer_code: {
            placeholder: '',
            rules: {
              required: true,
              message: '用户编码错误',
              regulation: 'special',
              rulesData: 'consumer_code'
            }
          },
          name: {
            placeholder: '请输入客户姓名',
            rules: {
              required: false,
              message: '角色名100个汉字以下',
              regulation: 'elt_str',
              rulesData: 20
            }
          },
          phone: {
            placeholder: '请输入手机号码',
            rules: {
              required: false,
              message: '手机号码必须为11位',
              regulation: 'eq_str',
              rulesData: 11
            }
          },
          sex: {
            placeholder: '请选择性别',
            rules: {
              required: false,
              message: '性别选择错误',
              regulation: 'egt_str',
              rulesData: 1
            }
          },
          status: {
            placeholder: '请选择状态',
            rules: {
              required: false,
              message: '状态选择错误',
              regulation: 'egt_str',
              rulesData: 1
            }
          },
          id_card: {
            placeholder: '请输入身份证号码',
            rules: {
              required: false,
              message: '身份证填写错误',
              regulation: 'special',
              rulesData: 'id_card'
            }
          },
          urgent_name: {
            placeholder: '请输入紧急联系人姓名',
            rules: {
              required: false,
              message: '紧急联系人姓名输入错误',
              regulation: 'elt_str',
              rulesData: 20
            }
          },
          urgent_phone: {
            placeholder: '请输入紧急联系人电话',
            rules: {
              required: false,
              message: '紧急联系人电话输入错误',
              regulation: 'eq_str',
              rulesData: 11
            }
          },
          car_number: {
            placeholder: '请输入车牌号码',
            rules: {
              required: false,
              message: '车牌号码输入错误',
              regulation: 'eq_str',
              rulesData: 7
            }
          },
          remarks: {
            placeholder: '备注，200字节之内',
            rules: {
              required: false,
              message: '备注，200字节之内',
              regulation: 'elt_str',
              rulesData: 200
            }
          },
          registration_id: {
            placeholder: '请输入极光编码',
            rules: {
              required: false,
              message: '极光编码输入错误',
              regulation: 'elt_str',
              rulesData: 19
            }
          },
        },


      };

    },
    created() {
      _this = this;

    },
    methods: {

      groupList() {


        // 请求公司管理接口获取公司唯一编码
        _this.$post(
          "/group/groupWalletLists",
          _this.group_options_data
        ).then(res => {

          _this.selectPages_data = res;
          _this.options_group_code = res.data;

        }).catch((err) => {

        })

      },

      //搜索的下拉框弹出触发
      modeVisibleChange(val) {


        _this.groupList();

      },

      modeChange(val) {

        _this.submit_data.group_wallet_code = val;

      },


      selectPages_function(search_data) {
        _this.group_options_data = search_data;

        _this.groupList();
      },



      // 关闭方法
      closeDialog() {
        _this.show = false;

        _this.submit_data = {
          consumer_code: '',
          name: '',
          phone: '',
          password: '',
          sex: '',
          status: '',
          id_card: '',
          urgent_name: '',
          urgent_phone: '',
          car_number: '',
          remarks: '',
          registration_id: '',
          group_wallet_code:'',
          clear_field:''

        };
        _this.value_group_code = '';
        _this.value_sex_code = '';
        _this.value_status_code = '';
        _this.money_show = false;
        _this.money_data = [];
        _this.group_wallet_code = '';
      },

      sexChange(val) {

        _this.submit_data.sex = val.toString();

      },

      statusChange(val) {

        _this.submit_data.status = val.toString();

      },
      // 提交
      onSubmit() {

        // 如果密码为空则删除submit_data.password
        if (_this.submit_data.password == '' || _this.submit_data.password == undefined) {

          delete _this.submit_data.password;

        }


        if(_this.submit_data.group_wallet_code == ''){

          _this.submit_data.clear_field = _this.group_wallet_code

        }

        console.log(_this.submit_data);
        _this.$post(
            "/consumer/editConsumerSubmit",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            this.$message.success(res.msg);
            _this.closeDialog();
          }).catch(res => {

          })
      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>